import { render, staticRenderFns } from "./Contrato.vue?vue&type=template&id=be2ee370&"
import script from "./Contrato.vue?vue&type=script&lang=js&"
export * from "./Contrato.vue?vue&type=script&lang=js&"
import style0 from "./Contrato.vue?vue&type=style&index=0&id=be2ee370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports